import axios from 'axios';

import type {
    CascadeReport,
    LiveReport,
    NetworkReport,
    ReportFilters,
} from '@/types/cascade-report';

const PRICE_STRUCTURE_API_URL =
    import.meta.env.VITE_PRICE_STRUCTURE_API_URL || 'http://localhost:8083';

const client = axios.create({
    baseURL: PRICE_STRUCTURE_API_URL,
    headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

/** Só manda o que foi preenchido — filtro vazio não vira `?block=null`. */
const params = (filters: ReportFilters): Record<string, string> => {
    const query: Record<string, string> = {};
    if (filters.domainId) query.domain_id = String(filters.domainId);
    if (filters.start) query.start = filters.start;
    if (filters.end) query.end = filters.end;
    if (filters.block) query.block = filters.block;
    if (filters.country) query.country = filters.country;
    if (filters.src) query.src = filters.src;
    return query;
};

/** Relatório de um domínio. Sem `domainId`, a rede inteira. */
export const getCascadeReport = async (filters: ReportFilters): Promise<CascadeReport> => {
    const { data } = await client.get<CascadeReport>('/api/v1/cascade-events/report', {
        params: params(filters),
    });
    return data;
};

/** Ranking dos domínios no período. */
export const getCascadeDomains = async (filters: ReportFilters): Promise<NetworkReport> => {
    const { data } = await client.get<NetworkReport>('/api/v1/cascade-events/domains', {
        params: params(filters),
    });
    return data;
};

/** Hoje até agora, direto do evento cru. Não passa pela consolidação diária. */
export const getCascadeLive = async (domainId?: number | null): Promise<LiveReport> => {
    const { data } = await client.get<LiveReport>('/api/v1/cascade-events/live', {
        params: domainId ? { domain_id: String(domainId) } : {},
    });
    return data;
};
